"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var classNames = require("classnames");

var withResponsive_1 = require("../decorators/withResponsive");

var inputable_1 = require("../decorators/inputable");

var withStyles_1 = require("../decorators/withStyles");

var NativeSelect_styles_1 = require("./NativeSelect.styles");

var ReactSelect_1 = require("./ReactSelect");

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var handleEvent_1 = require("../assets/handleEvent");

var baseProps_1 = require("../assets/baseProps");

var NativeSelect =
/** @class */
function (_super) {
  __extends(NativeSelect, _super);

  function NativeSelect() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onChange = function (_a) {
      var target = _a.target;

      if (!target.multiple) {
        return handleEvent_1.handleEvent(_this.props.onChange, target.value);
      } // в onChange мультиселекта нужно прокинуть массив выбранных option'ов


      var options = target.options;
      var values = []; // мы компилим 2kit в ES5, а в нём коллекции не итерабельны, так что по-старинке
      // tslint:disable-next-line:prefer-for-of

      for (var i = 0; i < options.length; i++) {
        if (options[i].selected) {
          values.push(options[i].value);
        }
      }

      return handleEvent_1.handleEvent(_this.props.onChange, values);
    };

    return _this;
  }

  NativeSelect.prototype.render = function () {
    var _a = this,
        props = _a.props,
        onChange = _a.onChange;

    var classes = props.classes,
        autoFocus = props.autoFocus,
        defaultValue = props.defaultValue,
        value = props.value,
        nativeSelectInlineStyles = props.nativeSelectInlineStyles,
        placeholder = props.placeholder;

    var _b = ReactSelect_1.convertProps(props),
        options = _b.options,
        disabled = _b.disabled,
        multi = _b.multi,
        name = _b.name;

    var currentValue = [];
    /**
     * Почему так запутано?
     *
     * https://github.com/facebook/react/issues/13222
     *
     * Потому что в react16 появился баг, при рендере через defaultValue/value
     * в нативном select после рендера скролл не прокручивается до выбранного элемента
     * это обходим с помощью установки selected непосредственно <options> элементам
     * Но - если выбрано больше одного элемента то такой способ не подходит!
     * TODO: После починки рендера <select> в react16 нужно будет удалить установку selected <options> элементам
     */

    if (value !== void 0) {
      currentValue = Array.isArray(value) ? value : [value];
    } else if (defaultValue !== void 0) {
      currentValue = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
    }

    return React.createElement("div", __assign({}, baseProps_1.default(props), {
      className: classNames(classes.nativeSelect, mobileStylesHelper_1.createMobileClasses(props))
    }), React.createElement("select", {
      defaultValue: currentValue.length !== 1 ? defaultValue : void 0,
      value: currentValue.length !== 1 ? value : void 0,
      onChange: onChange,
      className: classes.select,
      autoFocus: autoFocus,
      disabled: disabled,
      multiple: multi,
      name: name,
      style: nativeSelectInlineStyles && nativeSelectInlineStyles()
    }, placeholder && React.createElement("option", {
      className: classes.option,
      selected: true,
      disabled: true
    }, placeholder), options.filter(function (option) {
      return !option.hr && !option.unselectable;
    }).map(function (option) {
      return React.createElement("option", {
        className: classes.option,
        key: option.value,
        value: option.value,
        selected: currentValue.length === 1 && currentValue.includes(option.value)
      }, option.label);
    })), React.createElement("div", {
      className: classes.arrow
    }, ReactSelect_1.arrowRenderer({
      isOpen: false
    })));
  };

  NativeSelect = __decorate([withResponsive_1.withResponsive, inputable_1.inputable, withStyles_1.withStyles(NativeSelect_styles_1.default)], NativeSelect);
  return NativeSelect;
}(React.Component);

exports.default = NativeSelect;